import gql from 'graphql-tag'

export default gql`
mutation ($_id: MongoID!   ){
    removeTeacherUser(_id:$_id){
        recordId
      }
}
`
